export const STORAGE_KEY = 'anonymous_session_id';

const generateUuid = (): string => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  // Fallback UUID v4 format
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getAnonymousSessionId = (): string | null => {
  if (!window.localStorage) {
    return null;
  }

  return window.localStorage.getItem(STORAGE_KEY);
};

export const ensureAnonymousSessionId = (): string | null => {
  if (!window.localStorage) {
    return null;
  }

  let id = window.localStorage.getItem(STORAGE_KEY);

  if (!id) {
    id = generateUuid();
    window.localStorage.setItem(STORAGE_KEY, id);
  }

  if (!isValidUuid(id)) {
    id = generateUuid();
    window.localStorage.setItem(STORAGE_KEY, id);
  }

  return id;
};

const isValidUuid = (value: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
};

export const clearAnonymousSessionId = (): void => {
  if (!window.localStorage) {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
};

export const isAnonymousMode = (): boolean => {
  if (!window.localStorage) {
    return false;
  }

  const token = window.localStorage.getItem('auth_token');
  return !token;
};
